import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface ChainState {
  currentChain: string;
  bnbConnected: boolean;
  solanaConnected: boolean;
  balances: {
    bnb: string;
    solana: string;
  };
  accounts: {
    bnb: string | null;
    solana: string | null;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: ChainState = {
  currentChain: 'solana', // Default to Solana for testing
  bnbConnected: false,
  solanaConnected: false,
  balances: {
    bnb: '0',
    solana: '0',
  },
  accounts: {
    bnb: null,
    solana: null,
  },
  isLoading: false,
  error: null,
};

const chainSlice = createSlice({
  name: 'chain',
  initialState,
  reducers: {
    setCurrentChain: (state, action: PayloadAction<string>) => {
      state.currentChain = action.payload;
      state.error = null;
    },
    setBnbConnected: (state, action: PayloadAction<boolean>) => {
      state.bnbConnected = action.payload;
      if (!action.payload) {
        state.accounts.bnb = null;
        state.balances.bnb = '0';
      }
    },
    setSolanaConnected: (state, action: PayloadAction<boolean>) => {
      state.solanaConnected = action.payload;
      if (!action.payload) {
        state.accounts.solana = null;
        state.balances.solana = '0';
      }
    },
    setBnbAccount: (state, action: PayloadAction<string | null>) => {
      state.accounts.bnb = action.payload;
    },
    setSolanaAccount: (state, action: PayloadAction<string | null>) => {
      state.accounts.solana = action.payload;
    },
    setBnbBalance: (state, action: PayloadAction<string>) => {
      state.balances.bnb = action.payload;
    },
    setSolanaBalance: (state, action: PayloadAction<string>) => {
      state.balances.solana = action.payload;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearError: state => {
      state.error = null;
    },
    resetChainState: state => {
      state.bnbConnected = false;
      state.solanaConnected = false;
      state.accounts.bnb = null;
      state.accounts.solana = null;
      state.balances.bnb = '0';
      state.balances.solana = '0';
      state.error = null;
    },
  },
});

export const {
  setCurrentChain,
  setBnbConnected,
  setSolanaConnected,
  setBnbAccount,
  setSolanaAccount,
  setBnbBalance,
  setSolanaBalance,
  setLoading,
  setError,
  clearError,
  resetChainState,
} = chainSlice.actions;

export default chainSlice.reducer;
